import { workflowsService } from "./workflows-service";

const WORKFLOWS_SERVICE_LOCK = workflowsService.addStepLock;

/**
 * Workflows: the Add-step menu (P5-2). Included in `engage.workflows.addStep`.
 * `keywords.<step type or preset id>` are comma-separated search words in this language; the English names people know
 * the steps by (Intercom's "Fin", "data connector"...) are `ADD_STEP_ALIASES` in `@sagot/constants`.
 */
export const workflowsAddStep = {
  searchLabel: "Add step",
  searchPlaceholder: "Search",
  results_one: "{{count}} result",
  results_other: "{{count}} results",
  sections: {
    replace: "Replace with",
    suggested: "Suggested next steps",
    content: "Add content to path",
    actions: "Actions",
    flow: "Flow",
  },
  viewMore: "View more ({{count}})",
  moreOf: "{{section}}: more steps",
  viewLess: "View less",
  replaceNotice: "Steps after {{step}} never run. Replace it, or connect its exits to another path.",
  replaced: "Replaced {{from}} with {{to}}.",
  locks: {
    service: WORKFLOWS_SERVICE_LOCK,
    plan: "needs the {{plan}} plan",
    conversation: "Needs a conversation, so it is not available on triggers that run without one.",
  },
  empty: {
    title: "No step matches “{{query}}”",
    body: "Try another word, such as “tag”, “message” or “wait”.",
    clear: "Clear search",
  },
  presets: {
    close_conversation: "Close conversation",
    resolve_conversation: "Resolve conversation",
  },
  keywords: {
    ...workflowsService.keywords,
    send_webhook: "webhook, post, http, endpoint, notify system",
    add_tags: "tag, label, categorize",
    remove_tags: "untag, remove label, tag",
    assign: "assignee, owner, route, team, give to",
    set_status: "open, waiting, resolved, closed, state",
    add_note: "note, comment, internal",
    update_lead: "lead, stage, crm, owner",
    notify_staff: "alert, ping, tell the team, notification",
    apply_sla: "sla, deadline, service level, response target",
    set_priority: "priority, urgent, high",
    email_visitor: "email, mail, send an email",
    set_attribute: "attribute, property, save, custom field",
    run_workflow: "reusable, call, subflow, another workflow",
    http_request: "data connector, call an action, http, api, request, fetch, lookup, endpoint",
    send_message: "message, text, say, write",
    reply_buttons: "buttons, quick replies, choices, options, menu",
    collect_data: "ask, question, form, details, field, collect",
    let_assistant_answer: "ai, assistant, bot, answer, knowledge",
    show_booking: "book, appointment, calendar, schedule, meeting",
    show_lead_form: "lead, contact, form, capture",
    hand_to_person: "human, person, agent, handoff, handover, staff",
    expected_reply_time: "reply time, how long, response time",
    ask_rating: "rating, feedback, stars, csat, survey",
    branch: "condition, if, else, split, decide",
    apply_rules: "rules, conditions, several actions",
    wait: "delay, pause, timer, later, after",
    wait_for_webhook: "callback, incoming, external system, hook",
    go_to_path: "jump, path, continue, go to",
    end: "stop, finish, done, exit",
    close_conversation: "close, closed, finish conversation",
    resolve_conversation: "resolve, resolved, solved, done",
    collect_reply: "reply, customer reply, free text, type, answer, wait for reply, ask",
    disable_reply: "lock, disable, no typing, composer, block",
    enable_reply: "unlock, enable, allow typing, composer",
    snooze: "snooze, remind, later, hold, postpone",
    set_language: "language, locale, translate, filipino, english",
    show_article: "article, help article, knowledge, link, website, page, guide, card",
    add_summary_note: "summary, summarise, summarize, ai note, recap, internal note",
  },
} as const;
